import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {},
  offerDropdown: {
    minWidth: "400px",
  },
  submitBtn: {
    marginTop: theme.spacing(1),
  },
  btnGroup: {
    display: "inline-flex",
    float: "right",
  },
  loadingSpinner: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
}));
